import { Plus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import type { AutomationStep } from "@/types/Automation";
import type { StepNodeData } from "../types";

export function BeehiivCreateSubscriberFields({
  step,
  onBeehiivAutomationIdsChange,
}: {
  step: AutomationStep;
  onBeehiivAutomationIdsChange: StepNodeData["onBeehiivAutomationIdsChange"];
}) {
  const automationIds = step.data?.automationIds ?? [];

  return (
    <div className="p-4 space-y-3 nodrag" onPointerDownCapture={(e) => e.stopPropagation()}>
      <div className="space-y-2">
        <Label className="text-xs text-orange-800">Automation IDs (optional)</Label>
        <p className="text-xs text-muted-foreground">
          Beehiiv automation ids to enroll the subscriber after creation (one per row).
        </p>
        <div className="space-y-2">
          {automationIds.map((aid, ai) => (
            <div key={ai} className="flex gap-2">
              <Input
                value={aid}
                onChange={(e) => {
                  const next = [...automationIds];
                  next[ai] = e.target.value;
                  onBeehiivAutomationIdsChange({ stepId: step.id, automationIds: next });
                }}
                placeholder="Automation ID"
                className="text-sm"
              />
              <Button
                type="button"
                variant="ghost"
                size="icon"
                className="shrink-0 h-8 w-8"
                onClick={() => {
                  const next = automationIds.filter((_, i) => i !== ai);
                  onBeehiivAutomationIdsChange({ stepId: step.id, automationIds: next });
                }}
              >
                <Trash2 className="h-3 w-3" />
              </Button>
            </div>
          ))}
          <Button
            type="button"
            variant="outline"
            size="sm"
            className="w-full text-sm"
            onClick={() =>
              onBeehiivAutomationIdsChange({
                stepId: step.id,
                automationIds: [...automationIds, ""],
              })
            }
          >
            <Plus className="h-4 w-4 mr-1" />
            Add automation
          </Button>
        </div>
      </div>
    </div>
  );
}
